import React from 'react';

import { getAllLayers, getShieldSectionsArray } from 'pxc-editor-core/helpers/schema';
import { detectAllFonts } from 'pxc-editor-material-svg-rendering/helpers/general';
import LineComponent from 'pxc-editor-material-svg-rendering/components/shared/PrimitiveRenderer/Line';
import SectionRenderer from 'pxc-editor-material-svg-rendering/components/shared/SectionRenderer';

import { createClassName } from '@/helpers';

import BasePrintRenderer from './BasePrintRenderer';

export default class ShieldContentPrintRenderer extends BasePrintRenderer {
  getAllLayers() {
    const { printObjId: shieldId, pages } = this.props;
    return getAllLayers(shieldId, pages);
  }

  mapSection(section, resizeType) {
    const { x, y, width, height, id, fillColor, ...formatProps } = section;
    const rectProps = { x, y, width, height };
    const clickable = false;
    const draggable = false;
    const className = createClassName({ clickable, draggable });

    return (
      <SectionRenderer
        key={`${id}-section-component`}
        id={id}
        className={className}
        svgStyleProps={{ stroke: 'none' }}
        fillColor={null} // can be null for transparent
        resizeType={resizeType} // needed for recalculation of auto line break
        scaleCoef={1}
        rectProps={rectProps}
        formatProps={{ ...formatProps }}
        section={null}
        shield={null}
        isSectionSelected={false}
        hideSection={true}
        hideContent={false}
        clickable={clickable}
        skipFirstClickTapOnDbl={false}
        draggable={draggable}
        dragTransforms={null}
        resizable={false}
        onFastClickTap={null}
        onDblClickTap={null}
        onDragEnd={null}
        onResize={() => {}}
        groupIdPostfix="-print"
      />
    );
  }

  render() {
    this.checkBaseProps();

    const { page: currentPage, shield: currentShield } = this.getAllLayers();
    const { primitiveProps } = currentShield;
    const sections = getShieldSectionsArray(currentShield, currentPage.sections);

    const transforms = [];
    const corrRectProps = { x: primitiveProps.x, y: primitiveProps.y, width: primitiveProps.w, height: primitiveProps.h };
    const renderShapes = this.buildRenderedShapes(currentPage);
    const borderLines = this.buildBorderLines({ currentPage, renderShapes });
    const otherOptions = { fonts: detectAllFonts(sections) };

    return this.renderSvg(
      corrRectProps,
      transforms,
      otherOptions,
      <>
        {sections.map(section => this.mapSection(section))}
        {borderLines.map(({ position, section, primitiveProps, style }) => (
          <LineComponent key={`line_${position}_${section.id}`} style={style} primitiveProps={primitiveProps} />
        ))}
      </>,
    );
  }
}
